// extracted by mini-css-extract-plugin
module.exports = {"mainHeader":"Table_mainHeader__B3F6x","container":"Table_container__2izLw","table":"Table_table__2d_gO","header":"Table_header__17vZP","cell":"Table_cell__1Xr7u"};